import Vue from 'vue'

export default {
  getIncidents ({ commit }) {
    return Vue.api.get('engine/incidents')
      .then((res) => commit('init', { incidents: res.data }))
  }
}
